/**
 * Ensure form.system_fields_config is a plain object when the API still
 * returns a JSON string (or after client-side merges).
 */
export function normalizeFormForReceiptLabel(form) {
  if (!form || typeof form !== 'object') return form;
  const cfg = form.system_fields_config;
  if (cfg == null) return form;
  if (typeof cfg === 'object' && !Array.isArray(cfg)) return form;
  if (typeof cfg === 'string') {
    try {
      const parsed = JSON.parse(cfg);
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        return { ...form, system_fields_config: parsed };
      }
    } catch {
      /* ignore */
    }
    return { ...form, system_fields_config: null };
  }
  return form;
}

/**
 * Label for the campaign receipt upload control, from
 * campaign_forms.system_fields_config.system_receipt.field_label (JSON).
 */
export function getReceiptUploadLabel(form, fallback = 'Upload Receipt') {
  let cfg = form?.system_fields_config;
  if (typeof cfg === 'string') {
    try {
      cfg = JSON.parse(cfg);
    } catch {
      cfg = null;
    }
  }
  if (!cfg || typeof cfg !== 'object' || Array.isArray(cfg)) {
    return fallback;
  }
  const raw = cfg.system_receipt?.field_label;
  if (typeof raw !== 'string') return fallback;
  const t = raw.trim();
  return t || fallback;
}

/**
 * Short noun for admin tables (e.g. entries list): "Resume Upload" -> "Resume".
 * When the form has no custom receipt label, returns "Receipt".
 */
export function getReceiptColumnName(form) {
  let cfg = form?.system_fields_config;
  if (typeof cfg === 'string') {
    try {
      cfg = JSON.parse(cfg);
    } catch {
      cfg = null;
    }
  }
  if (!cfg || typeof cfg !== 'object' || Array.isArray(cfg)) {
    return 'Receipt';
  }
  const raw = typeof cfg.system_receipt?.field_label === 'string' ? cfg.system_receipt.field_label.trim() : '';
  if (!raw) return 'Receipt';
  if (/^upload\s+receipt$/i.test(raw)) return 'Receipt';
  const stripped = raw.replace(/\s+upload$/i, '').trim();
  if (stripped) return stripped;
  const first = raw.split(/\s+/)[0];
  if (first && !/^upload$/i.test(first)) return first;
  return 'Receipt';
}
